module.exports = __webpack_public_path__ + "img/add-folder.48c822b8.svg";